var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{staticClass:"main-container"},[_c('navbar'),_c('app-main'),_c('foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }